
const ScrollRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    fill="none"
    viewBox="0 0 30 30"
  >
    <rect
      width="30"
      height="30"
      x="30"
      y="30"
      fill="#F0F0F0"
      rx="15"
      transform="rotate(180 30 30)"
    ></rect>
    <path
      stroke="#1777CF"
      strokeLinecap="square"
      strokeWidth="3"
      d="m18.457 21.6-6.914-6.864L18.457 8.4"
    ></path>
  </svg>
);

export default ScrollRight;
